import { useQuery } from '@tanstack/react-query'
import { getCurrentAccount } from 'api/account'
import { AuthContext, AuthContextType } from 'context/AuthContext'
import { useContext } from 'react'

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error('useAuth must be used within an AuthContextProvider')
    }
    return context
}

export const useCurrentAccount = () => {
    const {
        data: currentAccount,
        isLoading: isLoadingCurrentAccount,
        error: errorCurrentAccount,
        refetch,
    } = useQuery({
        queryKey: ['currentAccount'],
        queryFn: () => getCurrentAccount(),
        retry: false,
        staleTime: 0,
    })

    return {
        currentAccount: errorCurrentAccount ? null : currentAccount,
        isLoadingCurrentAccount,
        errorCurrentAccount,
        refetch,
    }
}
